import React from 'react';
import documentImportGif from '../assets/document_import.gif';
import documentImportReviewGif from '../assets/document_import_review.gif';
import themeImportPng from '../assets/theme_import.png';
import playlistEditorPng from '../assets/playlist_editor.png';
import scheduledSlidePng from '../assets/scheduled_slide.png';
import slideshowExportPng from '../assets/slideshow_export.png';
import pcoServicesIcon from '../assets/pco_services_icon.png';

export const hero = {
  headline: 'Collaborate and edit slides from anywhere',
  subhead: 'A set of cloud-based tools and sync for church production and communication',
  preamble: 'Import Word documents, import and export to Planning Center, apply repeatable templates, convert automatically to .pro format, make edits, share, and export to ProPresenter.',
  primaryCta: { text: 'Start 30-day free trial', href: '/accounts/new' },
  secondaryCta: { text: 'Log in', href: '/login' },
  demoImage: documentImportReviewGif,
  treatment: {
    headline: 'Turn sermon notes into ProPresenter-ready slides from any browser',
    highlightWord: 'browser',
    subhead: 'Cloud-based worship slides and lobby signage for church production teams and volunteers.',
  },
};

const PCOServicesIcon = ({ className = '' }) => (
  <img src={pcoServicesIcon} alt="Planning Center Services" className={className} />
);

export const apps = [
  {
    key: 'slides',
    name: 'Slides',
    tagline: 'Build, edit, and share presentation slides from any browser.',
    highlightWord: 'any',
    features: [
      {
        title: 'Document import',
        body: 'Drop in a Word doc or .pages file. WorshipKit splits it into slides — review and tweak before you generate the final bundle.',
        media: { type: 'gif', src: documentImportGif, alt: 'Document import flow showing review-before-generate stage' },
      },
      {
        title: 'Repeatable templates',
        body: 'Save fonts, colors, and layouts once. Apply them to any service with one click — every week looks consistent.',
        media: { type: 'image', src: themeImportPng, alt: 'Theme picker with repeatable template options' },
      },
      {
        title: 'Plays nice with others',
        body: (
          <>
            Sync down songs from Planning Center and automatically generate slides. <strong className="font-semibold">Coming soon:</strong> Sync up to Planning Center, or create sermon slides from Google Docs, and export to PowerPoint or Google Docs slideshows.
          </>
        ),
        media: { type: 'icon', alt: 'Planning Center Services' },
      },
    ],
  },
  {
    key: 'billboard',
    name: 'Billboard',
    tagline: 'Schedule announcements across weeks, and display in the lobby and sanctuary from a single playlist.',
    highlightWord: 'weeks',
    features: [
      {
        title: 'Scheduled slides',
        body: 'Set start and end times per slide. Slides appear and rotate themselves — no morning-of scramble.',
        media: { type: 'image', src: scheduledSlidePng, alt: 'Scheduled slide editor' },
      },
      {
        title: 'In-browser player',
        body: 'Open a URL on any TV browser. No app to install, no extra hardware to manage, no rebooting before service.',
        media: { type: 'image', src: playlistEditorPng, alt: 'Billboard playlist editor' },
      },
      {
        title: 'Export to ProPresenter, .pptx, or Keynote',
        body: 'Take it offline when you need to. One click and your playlist becomes a .pro, .pptx, or .key file.',
        media: { type: 'image', src: slideshowExportPng, alt: 'Slideshow export options' },
      },
    ],
  },
];

export const testimonial = null;

export const closingCta = {
  headline: 'Ready to simplify your Sunday morning?',
  body: 'Start a free trial — no credit card required. Bring your team along when you are ready.',
  primaryCta: { text: 'Start 30-day free trial', href: '/accounts/new' },
};

export const faqs = [
  {
    q: 'Does WorshipKit replace ProPresenter?',
    a: 'No. WorshipKit exports .pro files — it makes ProPresenter easier to feed, not obsolete.',
  },
  {
    q: 'Can a non-technical volunteer learn it?',
    a: 'Yes. It runs in the browser with nothing to install, so a new volunteer can be productive on their first Sunday.',
  },
  {
    q: 'What if the internet goes down on Sunday morning?',
    a: 'Export your slides to .pro (or .pptx/.key) ahead of time and run them offline from ProPresenter or Keynote.',
  },
  {
    q: 'Can I cancel anytime?',
    a: 'Yes. There’s no contract — cancel whenever you like.',
  },
  {
    q: 'Is my data safe?',
    a: 'Your content is stored securely and never shared. You can export or delete it at any time.',
  },
];

export { PCOServicesIcon };

export const ProductHuntBadge = ({ theme = 'light' }) => (
  <a
    href="https://www.producthunt.com/products/worshipkit?embed=true&utm_source=badge-featured&utm_medium=badge&utm_campaign=badge-worshipkit"
    target="_blank"
    rel="noopener noreferrer"
  >
    <img
      alt="WorshipKit - Collaborative church slides — Word in, ProPresenter out | Product Hunt"
      width="250"
      height="54"
      src={`https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=1137575&theme=${theme}&t=1777742333261`}
    />
  </a>
);
